import { render, staticRenderFns } from "./InProgress.vue?vue&type=template&id=2f2c6ffe&scoped=true&"
import script from "./InProgress.vue?vue&type=script&lang=js&"
export * from "./InProgress.vue?vue&type=script&lang=js&"
import style0 from "./InProgress.vue?vue&type=style&index=0&id=2f2c6ffe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2c6ffe",
  null
  
)

export default component.exports